"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = {
  /** Currency, e.g.: "BRL" */
  currency: _propTypes2["default"].string,

  /** Product selling price */
  sellingPrice: _propTypes2["default"].number,

  /** Product list price */
  listPrice: _propTypes2["default"].number,

  /** True if the product is unavailable */
  unavailable: _propTypes2["default"].bool,

  /** Set visibility of list price */
  showListPrice: _propTypes2["default"].bool.isRequired,

  /** Set visibility of labels */
  showLabels: _propTypes2["default"].bool.isRequired,

  /** Set visibility of installments */
  showInstallments: _propTypes2["default"].bool.isRequired,

  /** Set visibility of savings */
  showSavings: _propTypes2["default"].bool,

  /** Shows 'From ' before the actual price */
  showStartingAt: _propTypes2["default"].bool,

  /** Text to the selling price's label */
  labelSellingPrice: _propTypes2["default"].string,

  /** Available installments */
  installments: _propTypes2["default"].arrayOf(_propTypes2["default"].shape({
    /** Installment value */
    Value: _propTypes2["default"].number.isRequired,

    /** Interest rate (zero if interest-free) */
    InterestRate: _propTypes2["default"].number.isRequired,

    /** Calculated total value */
    TotalValuePlusInterestRate: _propTypes2["default"].number,

    /** Number of installments */
    NumberOfInstallments: _propTypes2["default"].number.isRequired,

    /** Installment offer name */
    Name: _propTypes2["default"].string
  })),

  /** Classes to be applied to root element */
  className: _propTypes2["default"].string,

  /** Classes to be applied to loader root element */
  loaderClass: _propTypes2["default"].string,

  /** Classes to be applied to container of list price */
  listPriceContainerClass: _propTypes2["default"].string,

  /** Classes to be applied to label of price */
  listPriceLabelClass: _propTypes2["default"].string,

  /** Classes to be applied to price value */
  listPriceClass: _propTypes2["default"].string,

  /** Classes to be applied to selling price container */
  sellingPriceContainerClass: _propTypes2["default"].string,

  /** Classes to be applied to selling price label */
  sellingPriceLabelClass: _propTypes2["default"].string,

  /** Classes to be applied to selling price value */
  sellingPriceClass: _propTypes2["default"].string,

  /** Classes to be applied to savings container */
  savingsContainerClass: _propTypes2["default"].string,

  /** Classes to be applied to savings */
  savingsClass: _propTypes2["default"].string,

  /** Classes to be applied to installment element */
  installmentClass: _propTypes2["default"].string,

  /** Classes to be applied to installment container */
  installmentContainerClass: _propTypes2["default"].string,

  /** Classes to be applied to interest rate element */
  interestRateClass: _propTypes2["default"].string,

  /** Classes to be applied to the fromLabel */
  startingAtClass: _propTypes2["default"].string,

  /** Classes to be applied to the unavailable message */
  unavailableClass: _propTypes2["default"].string,

  /** Component and content loader styles */
  styles: _propTypes2["default"].object,

  /** intl property to format data */
  intl: _propTypes2["default"].any.isRequired
};